export default {
    setPeriods(state, periods) {
        state.periods = periods;
    },
    setActivePeriod(state, activePeriod) {
        state.activePeriod = activePeriod;
    },
    setManagePeriodDialog(state, status) {
        state.managePeriodDialog = status;
    },
    setManageDeletePeriodDialog(state, status) {
        state.deletePeriodDialog = status;
    }
}
